let baseUrl = "https://shopify-api.michelle-oh.com";
document.addEventListener("DOMContentLoaded", async function () {
  refreshSavedDiamond();
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  try {
    // Fetch the data from the Storefront API
    await fetch(
      `${baseUrl}/admin/api/2024-04/orders.json?status=any&fields=line_items`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const entries = result.orders;
        for (let entry in entries) {
          for (let item in entries[entry].line_items) {
            if (entries[entry].line_items[item].product_id == "8867675013432") {
              const diamondVariantId =
                entries[entry].line_items[item].variant_id;
              deleteVariant(diamondVariantId);
            }
          }
        }
      })
      .catch((error) => console.error("Error:", error));
  } catch (error) {
    console.error("Error:", error);
  }
});

async function refreshSavedDiamond() {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  await fetch(
    `${baseUrl}/admin/api/2024-04/products/8867675013432/variants.json`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      const entries = result.variants;
      for (let entry in entries) {
        if (entries[entry].image_id) {
          const date1 = new Date(entries[entry].created_at);
          const date2 = new Date();
          const differenceInTime = date2.getTime() - date1.getTime();
          const differenceInDays = Math.round(
            differenceInTime / (1000 * 3600 * 24)
          );

          if (differenceInDays > 30) {
            deleteVariant(entries[entry].id);
          }
        }
      }
    })
    .catch((error) => console.error("Error:", error));
}

function syncQuantity(qty, variantId, imageId) {
  if (qty <= 1) {
    deleteVariant(variantId, imageId);
  }
}

function triggerDeleteVariant(variantId, element) {
  const isNivodaDiamond = $(element)
    .parent()
    .parent()
    .find(".cart-item__details")
    .find(".product-option dt")
    .html()
    .includes("Diamond for Made to Order Ring:");

  if (isNivodaDiamond) {
    const href = $(element).find("a").attr("href");
    const variantId = href.split("=")[1].split(":")[0];
    deleteVariant(variantId);
  }
}

async function deleteVariant(variantId) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "DELETE",
    headers: myHeaders,
  };
  try {
    await getVariantDetail(variantId).then((imageId) => {
      deleteImage(imageId);
    });
    await fetch(
      `${baseUrl}/admin/api/2024-04/products/8867675013432/variants/${variantId}.json`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => console.error("Error:", error));
  } catch (e) {
    console.log(e);
  }
}

async function deleteImage(imageId) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "DELETE",
    headers: myHeaders,
  };
  try {
    await fetch(
      `${baseUrl}/admin/api/2024-04/products/8867675013432/images/${imageId}.json`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => console.error("Error:", error));
  } catch (e) {
    console.log(e);
  }
}

async function getVariantDetail(variantId) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };
  let output;
  try {
    await fetch(
      `${baseUrl}/admin/api/2024-04/variants/${variantId}.json`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        output = result.variant?.image_id ?? null;
      })
      .catch((error) => console.error("Error:", error));
  } catch (e) {
    console.log(e);
  }
  return output;
}
